if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
      const skuInput = this.form.querySelector('input[name="sku"]');
      const VidInput = this.form.querySelector('input[name="id"]');
      if (skuInput && VidInput) {
          const sku = skuInput.value;
          const vid = VidInput.value;
          if (sku && vid) {
              console.log("Single-variant product → calling EDD");
              this.updateEDD(sku, vid);
          }
      }

    }

    // based on SKU show EDD message
    // formatDate(dateStr) {
    //   const d = new Date(dateStr);
    //   const day = d.getDate();

    //   // Determine suffix
    //   const suffix =
    //     day % 10 === 1 && day !== 11 ? "st" :
    //     day % 10 === 2 && day !== 12 ? "nd" :
    //     day % 10 === 3 && day !== 13 ? "rd" : "th";

    //   // Always return exactly 3-letter month
    //   const month = d.toLocaleString('en-US', { month: 'short' }).slice(0, 3);

    //   return `${day}${suffix} ${month}`;
    // }

    // updateEDD(sku) {
    //   const eddBox = document.getElementById("edd-message");
    //   const eddMobBox = document.getElementById("edd-messageMob");
    //   const parentBoxes = document.querySelectorAll(".api_edd_msg"); // parent wrapper
    //   parentBoxes.forEach(parentBox => {
    //     parentBox.classList.add("hidden");
    //   });
    //   if (!eddMobBox) return;
    //   if (!eddBox) return;
    //   if (!sku) return;
    //   fetch(`https://api.trampolinestore.uk/fableroom/edd/?format=json&sku=${sku}`)
    //     .then(res => res.json())
    //     .then(data => {
    //       // 🚫 Skip if API returns error
    //       if (data.error) {
    //         console.warn(`EDDV skipped for SKU ${sku}: ${data.error}`);
    //         // return "";
    //         parentBoxes.forEach(parentBox => {
    //           parentBox.classList.add("hidden");
    //         });

    //       }

    //       console.log(data,"here product from js");
    //       let message = "";
    //       if (data.message) {
    //         message = data.message;
    //       } else if (data.min_edd && data.max_edd) {
    //         const minDate = this.formatDate(data.min_edd);
    //         const maxDate = this.formatDate(data.max_edd);
    //         message = `Delivery between ${minDate} to ${maxDate}`;
    //       }
    //       parentBoxes.forEach(parentBox => {
    //         if (message) {
    //           parentBox.classList.remove("hidden"); 
    //           eddBox.textContent = message;
    //           eddMobBox.textContent = message;
    //           const divElement = document.querySelector('#shipping-msg');
    //           if (divElement) {
    //             divElement.value = message;
    //           }
    //         
    //         } else {
    //           parentBox.classList.add("hidden");   // hide if no message
    //         }
    //       });
         
    //     })
    //     .catch(err => console.error("EDD API Error:", err));
    // }

    // new api 
    // new api 
    // new api 
    updateEDD(sku, vid) {
      const eddBox = document.getElementById("edd-message");
      const parentBoxes = document.querySelectorAll(".api_edd_msg");

      this.checkExpressMetaVal(vid);
      // Hide initially
      parentBoxes.forEach(parentBox => {
        parentBox.classList.add("hidden");
      });

      if (!eddBox || !sku) return;

      const countryCode = window?.Shopify?.country;

      // const apiUrl =
      // countryCode === "DE"
      //   ? `https://api.trampolinestore.uk/fableroom/de/edd/?format=json&sku=${sku}`
      //   : `https://api.trampolinestore.uk/fableroom/edd/?format=json&sku=${sku}`;
      
      const apiUrl =`https://api.trampolinestore.uk/fableroom/edd/?format=json&sku=${sku}`;

      fetch(apiUrl)
        .then(res => res.json())
        .then(data => {

          console.log(data, "FORM PDP EDD response");

          // ❗ If API error → hide everything
          if (data.error) {
            console.warn(`EDD skipped for SKU ${sku}: ${data.error}`);
            parentBoxes.forEach(parentBox => parentBox.classList.add("hidden"));
            this.checkExpressMetaVal(vid);
            return;
          }

          // ✅ PRIORITY LOGIC (dynamic)
          let message = "";

          if (data.message) {
            message = data.message.trim();
          } else if (data.shipping_message) {
            message = data.shipping_message.trim();
          }

          parentBoxes.forEach(parentBox => {
            if (message) {
              // ✅ Show message
              parentBox.classList.remove("hidden");

              eddBox.textContent = message;

              // ✅ Update hidden inputs (used for cart)
              const divElement = document.querySelector('#shipping-msg');
              if (divElement) {
                divElement.value = message;
              }

              

            } else {
              // ❗ Clear old message if API returns blank
              parentBox.classList.add("hidden");

              eddBox.textContent = "";

              const divElement = document.querySelector('#shipping-msg');
              if (divElement) {
                divElement.value = "";
              }

            
            }
          });
          this.checkExpressMetaVal(vid);

        })
        .catch(err => {
          console.error("EDD API Error:", err);

          // ❗ On error also clear
          parentBoxes.forEach(parentBox => parentBox.classList.add("hidden"));

          if (eddBox) eddBox.textContent = "";
          this.checkExpressMetaVal(vid);
        });
    }
    // new api 
    // new api 
    // new api 

    checkExpressMetaVal(currentVar) {
      const parentBoxes = document.querySelectorAll(".api_edd_msg");
      const metafieldJsonEl = document.getElementById("VariantMetafieldsJson-delivery_days");

      if (!metafieldJsonEl) {
        console.warn("VariantMetafieldsJson-delivery_days not found");
        return;
      }

      let variantMetafields = {};

      try {
        variantMetafields = JSON.parse(metafieldJsonEl.textContent);
      } catch (e) {
        console.error("Variant metafield JSON parse error:", e);
        return;
      }

      const variantId = String(currentVar || "");
      const variantData = variantMetafields?.[variantId] || {};

      const deliveryDays = Number(variantData.delivery_type);
      const variantBadges = variantData.variant_badges || [];

      const hasReadyToShip =
        Array.isArray(variantBadges) &&
        variantBadges.includes("Ready to Ship") &&
        variantBadges.includes("UK");

      const hasExpressDelivery =
        (deliveryDays === 3 || deliveryDays === 4 || deliveryDays === 6) &&
        hasReadyToShip;

      console.log("Delivery Days:", deliveryDays);
      console.log("Variant Badges:", variantBadges);
      console.log("Has Express Delivery:", hasExpressDelivery);

      parentBoxes.forEach(parentBox => {
        parentBox.classList.toggle("express-hidden", hasExpressDelivery);
      });
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      // Cart-drawer upsells can be clicked before initUpsellEDD has finished.
      // Resolve their EDD here so the line-item property is present in the
      // original add request instead of relying on a later cart repair.
      const upsellShippingInput = this.form.querySelector('.upsell-shipping-msg');
      const upsellCard = this.closest('.card--related');
      const upsellSku = upsellCard?.dataset.sku;
      if (upsellShippingInput && !upsellShippingInput.value.trim() && upsellSku) {
        try {
          const eddResponse = await fetch(
            `https://api.trampolinestore.uk/fableroom/edd/?format=json&sku=${encodeURIComponent(upsellSku)}`
          );
          if (eddResponse.ok) {
            const eddData = await eddResponse.json();
            let eddMessage = '';

            if (Array.isArray(eddData)) {
              const eddEntry = eddData.find((entry) => entry?.shipping_message || entry?.message);
              eddMessage = eddEntry?.shipping_message || eddEntry?.message || '';
            } else {
              eddMessage = eddData?.shipping_message || eddData?.message || '';
            }

            upsellShippingInput.value = String(eddMessage).trim();
          }
        } catch (error) {
          console.error('Upsell EDD request failed:', error);
        }
      }

      console.log("MMMMMMMMMMMMM");

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      const christmasWidget = this.closest('.js-product')?.querySelector('[data-christmas-shipping-widget]');
      const christmasCheckbox = christmasWidget?.querySelector('[data-christmas-shipping-checkbox]');
      const christmasSelected = Boolean(christmasCheckbox?.checked);
      const christmasFeeVariantId = Number(christmasWidget?.dataset.feeVariantId || 0);

      // Submit the product and its Christmas delivery fee atomically as two
      // linked lines. The normal FormData request is unchanged when unchecked.
      if (christmasSelected && christmasFeeVariantId) {
        const mainVariantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const properties = {};
        const bundleId = `christmas_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
        const bundleHandle = christmasWidget.dataset.productHandle;
        const bundleTitle = christmasWidget.dataset.productTitle;
        const christmasMessage = christmasWidget.dataset.deliveryMessage || '';

        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.*)\]$/);
          if (propertyMatch && String(value).trim() !== '') properties[propertyMatch[1]] = value;
        });
        properties['Christmas Shipping'] = christmasMessage;
        properties['_Christmas Free Shipping'] = 'true';
        properties['_Bundle product'] = bundleTitle;
        properties['_Bundle handle'] = bundleHandle;
        properties['_Bundle id'] = bundleId;
        properties['_Bundle item'] = 1;

        const mainItem = { id: mainVariantId, quantity, properties };
        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);

        fetchRequestOpts.headers['Content-Type'] = 'application/json';
        fetchRequestOpts.body = JSON.stringify({
          items: [
            mainItem,
            {
              id: christmasFeeVariantId,
              quantity: 1,
              properties: {
                '_Christmas shipping fee': 'Yes',
                '_Christmas Free Shipping': 'true',
                '_Bundle product': bundleTitle,
                '_Bundle handle': bundleHandle,
                '_Bundle id': bundleId,
                '_Bundle item': 2
              }
            }
          ],
          sections_url: window.location.pathname,
          sections: sections.split(',')
        });
      }

     

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        const addedItem = Array.isArray(data.items)
          ? (data.items.find((item) => item.variant_id === Number(formData.get('id'))) || data.items[0])
          : data;
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (document.getElementById('cart')) {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        } else if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          setTimeout(function(){
            console.log(data, "upsell item line item shipping msg changes ..Here data after submit");
            const itemSku = addedItem.sku;
            if (itemSku) {
              console.log("After Add product to cart → calling EDD");
              updateCartEddMessages();
            }
          },400);


          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === addedItem.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: addedItem.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === addedItem.quantity)
                ? itemInOldCart.quantity : addedItem.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: addedItem.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
          document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", {
              bubbles: true
          }));
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
